module.exports = __webpack_public_path__ + "static/wxshare.01612a59.png";